import React from 'react'
import {
  Select,
  Radio,
  // Checkbox,
  Input,
  InputNumber
  // DatePicker,
  // TimePicker
} from 'antd'

const select = ({ question, locale, ...props }) => (
  <Select {...props}>
    {question.items.map((item, itemIndex) => (
      <Select.Option key={item._id} value={item._id}>
        {item.value[locale]}
      </Select.Option>
    ))}
  </Select>
)

const radio = ({ question, locale, ...props }) => (
  <Radio.Group {...props}>
    {question.items.map((item, itemIndex) => (
      <Radio key={item._id} value={item._id}>{item.value[locale]}</Radio>
    ))}
  </Radio.Group>
)

const checkbox = ({ question, locale, ...props }) => (
  <Input type="text" {...props} />
)

const text = ({ question, locale, ...props }) => (
  <Input type="text" {...props} />
)

const textarea = ({ question, locale, ...props }) => (
  <Input type="textarea" {...props} />
)

const number = ({ question, locale, ...props }) => <InputNumber {...props} />

// const date = ({ question, locale, ...props }) => <DatePicker {...props} />
// const datetime = ({ question, locale, ...props }) => <DatePicker {...props} />
// const time = ({ question, locale, ...props }) => <TimePicker {...props} />

const multiselect = ({ question, locale, ...props }) => (
  <Select mode="multiple" {...props}>
    {question.items.map((item, itemIndex) => (
      <Select.Option key={item._id} value={item._id}>
        {item.value[locale]}
      </Select.Option>
    ))}
  </Select>
)

class DurationInput extends React.Component {
  state = {
    hours: 0,
    minutes: 0
  }  
  handleHourChange = (hours) => {
    // console.log({ hours })
    this.setState({
      hours
    }, () => {
      const { hours, minutes } = this.state
      const hh = ('0' + hours).slice(-2)
      const mm = ('0' + minutes).slice(-2)
      this.props.onChange(`${hh}:${mm}`)          
    })
  }
  handleMinuteChange = (minutes) => {
    // console.log({ minutes })
    this.setState({
      minutes
    }, () => {
      const { hours, minutes } = this.state
      const hh = ('0' + hours).slice(-2)
      const mm = ('0' + minutes).slice(-2)
      this.props.onChange(`${hh}:${mm}`)          
    })
  }
  componentWillMount() {
    const { value, defaultValue } = this.props
    const time = value || '00:00'
    console.log('receive', { value, time, defaultValue })
    const [hours, minutes] = time.split(':')
    this.setState({
      hours: parseInt(hours || 0, 10),
      minutes: parseInt(minutes || 0, 10)
    })
  }
  componentWillReceiveProps (nextProps) {
    // const { value, defaultValue } = nextProps
    // const time = value || '00:00'
    // console.log('receive', { value, time, defaultValue })
    // const [hours, minutes] = time.split(':')
    // this.setState({
    //   hours: parseInt(hours || 0, 10),
    //   minutes: parseInt(minutes || 0, 10)
    // })
  }
  render() {
    const { locale } = this.props
    const { hours, minutes } = this.state
    return <Input.Group compact>
      <InputNumber
        onChange={this.handleHourChange}
        value={hours}
        min={0}
        max={23}
        formatter={value => ('0' + value).slice(-2)}
        style={{ width: 60, textAlign: 'right' }}
      />
      <Input style={{ width: 10, padding: 0, borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff' }} placeholder=":" disabled />
      <InputNumber
        onChange={this.handleMinuteChange}
        value={minutes}
        min={0}
        max={59}
        formatter={value => ('0' + value).slice(-2)}
        style={{ width: 60, textAlign: 'right', borderLeft: 0 }}
      />
      <Input style={{ width: 100, pointerEvents: 'none', backgroundColor: '#fff' }} placeholder={{ en: 'hour:minutes', th: 'ชั่วโมง:นาที' }[locale]} disabled />
    </Input.Group>

  }
}

const duration = ({ question, locale, ...props }) => <DurationInput locale={locale} {...props} />

const rendererMap = {
  select,
  radio,
  checkbox,
  text,
  textarea,
  number,
  multiselect,
  duration
}

const renderQuestionInput = props =>
  rendererMap[props.question.inputType](props)
// console.log('props.inputKey', props.inputKey)
// console.log('props.key', props.key)
// console.log('props.question', props.question)

export default renderQuestionInput



// WEBPACK FOOTER //
// ./src/renderQuestionInput.js